import { useMemo } from 'react';
import { Cashier } from '@mews-commander/data-access';
import { CashPaymentFormField } from '../schema';
import { ProcessPaymentFormField } from '../../ProcessPaymentFormSchema';
import { PaymentFormProps } from '../../types';
import { getCurrencyDefaultValue } from '../utils';
import { useDefaultFormContext } from '../../useDefaultFormValues';

interface UseGetInitialFormValuesProps extends Pick<PaymentFormProps, 'accountId' | 'billId'> {
    data: Cashier[] | undefined;
}

export const useGetInitialFormValues = ({ data }: UseGetInitialFormValuesProps) => {
    const { defaultFormValues } = useDefaultFormContext();

    return useMemo(() => {
        const cashierDefaultValue = data?.[0];
        const cashierCurrencyDefaultValue = getCurrencyDefaultValue(
            defaultFormValues.currencyCode,
            cashierDefaultValue
        );

        return {
            ...defaultFormValues,
            [ProcessPaymentFormField.CurrencyCode]: cashierCurrencyDefaultValue || defaultFormValues.currencyCode,
            [CashPaymentFormField.CashierId]: cashierDefaultValue?.id || '',
        };
    }, [data, defaultFormValues]);
};
